// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --dark-navy-50: #ebf2f9;
    --dark-navy-100: #d7e6f4;
    --dark-navy-200: #b4cfe9;
    --dark-navy-300: #8cb6de;
    --dark-navy-400: #659dd2;
    --dark-navy-500: #4187c8;
    --dark-navy-600: #306da6;
    --dark-navy-700: #25537f;
    --dark-navy-800: #1a3c5b;
    --dark-navy-900: #0f2234;
    --dark-navy-950: #08121c;
    --dark-navy-main: var(--dark-navy-900);

    --chalk-50: #f7f7f7;
    --chalk-100: #f1f1f1;
    --chalk-200: #d6d6d6;
    --chalk-300: #bdbdbd;
    --chalk-400: #a1a1a1;
    --chalk-500: #878787;
    --chalk-600: #6b6b6b;
    --chalk-700: #525252;
    --chalk-800: #363636;
    --chalk-900: #1c1c1c;
    --chalk-950: #0d0d0d;
    --chalk-main: var(--chalk-100);

    --north-atlantic-50: #f6f8f8;
    --north-atlantic-100: #edf2f2;
    --north-atlantic-200: #dce5e5;
    --north-atlantic-300: #c8d6d5;
    --north-atlantic-400: #b0c4c3;
    --north-atlantic-500: #96b0b0;
    --north-atlantic-600: #799b99;
    --north-atlantic-700: #5c7b7a;
    --north-atlantic-800: #4c6665;
    --north-atlantic-900: #374948;
    --north-atlantic-950: #253231;
    --north-atlantic-main: var(--north-atlantic-700);

    --wine-red-50: #fdeded;
    --wine-red-100: #fbdadb;
    --wine-red-200: #f7b6b8;
    --wine-red-300: #f28d90;
    --wine-red-400: #ee686c;
    --wine-red-500: #e94349;
    --wine-red-600: #e51f25;
    --wine-red-700: #c5171c;
    --wine-red-800: #9d1216;
    --wine-red-900: #4e090b;
    --wine-red-950: #290506;
    --wine-red-main: var(--wine-red-800);

    --metallic-gold-50: #f9f6f1;
    --metallic-gold-100: #f5eee6;
    --metallic-gold-200: #e9dbc9;
    --metallic-gold-300: #decbb0;
    --metallic-gold-400: #d2b893;
    --metallic-gold-500: #c8a779;
    --metallic-gold-600: #bc945d;
    --metallic-gold-700: #94703d;
    --metallic-gold-800: #654c2a;
    --metallic-gold-900: #332615;
    --metallic-gold-950: #19130a;
    --metallic-gold-main: var(--metallic-gold-600);
  }
`, "",{"version":3,"sources":["webpack://./global-styles/colors.pcss"],"names":[],"mappings":"AACE;IACE,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,wBAAwB;IACxB,sCAAsC;;IAEtC,mBAAmB;IACnB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,8BAA8B;;IAE9B,4BAA4B;IAC5B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,6BAA6B;IAC7B,gDAAgD;;IAEhD,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,uBAAuB;IACvB,oCAAoC;;IAEpC,2BAA2B;IAC3B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,4BAA4B;IAC5B,8CAA8C;EAChD","sourcesContent":[":global {\n  :root {\n    --dark-navy-50: #ebf2f9;\n    --dark-navy-100: #d7e6f4;\n    --dark-navy-200: #b4cfe9;\n    --dark-navy-300: #8cb6de;\n    --dark-navy-400: #659dd2;\n    --dark-navy-500: #4187c8;\n    --dark-navy-600: #306da6;\n    --dark-navy-700: #25537f;\n    --dark-navy-800: #1a3c5b;\n    --dark-navy-900: #0f2234;\n    --dark-navy-950: #08121c;\n    --dark-navy-main: var(--dark-navy-900);\n\n    --chalk-50: #f7f7f7;\n    --chalk-100: #f1f1f1;\n    --chalk-200: #d6d6d6;\n    --chalk-300: #bdbdbd;\n    --chalk-400: #a1a1a1;\n    --chalk-500: #878787;\n    --chalk-600: #6b6b6b;\n    --chalk-700: #525252;\n    --chalk-800: #363636;\n    --chalk-900: #1c1c1c;\n    --chalk-950: #0d0d0d;\n    --chalk-main: var(--chalk-100);\n\n    --north-atlantic-50: #f6f8f8;\n    --north-atlantic-100: #edf2f2;\n    --north-atlantic-200: #dce5e5;\n    --north-atlantic-300: #c8d6d5;\n    --north-atlantic-400: #b0c4c3;\n    --north-atlantic-500: #96b0b0;\n    --north-atlantic-600: #799b99;\n    --north-atlantic-700: #5c7b7a;\n    --north-atlantic-800: #4c6665;\n    --north-atlantic-900: #374948;\n    --north-atlantic-950: #253231;\n    --north-atlantic-main: var(--north-atlantic-700);\n\n    --wine-red-50: #fdeded;\n    --wine-red-100: #fbdadb;\n    --wine-red-200: #f7b6b8;\n    --wine-red-300: #f28d90;\n    --wine-red-400: #ee686c;\n    --wine-red-500: #e94349;\n    --wine-red-600: #e51f25;\n    --wine-red-700: #c5171c;\n    --wine-red-800: #9d1216;\n    --wine-red-900: #4e090b;\n    --wine-red-950: #290506;\n    --wine-red-main: var(--wine-red-800);\n\n    --metallic-gold-50: #f9f6f1;\n    --metallic-gold-100: #f5eee6;\n    --metallic-gold-200: #e9dbc9;\n    --metallic-gold-300: #decbb0;\n    --metallic-gold-400: #d2b893;\n    --metallic-gold-500: #c8a779;\n    --metallic-gold-600: #bc945d;\n    --metallic-gold-700: #94703d;\n    --metallic-gold-800: #654c2a;\n    --metallic-gold-900: #332615;\n    --metallic-gold-950: #19130a;\n    --metallic-gold-main: var(--metallic-gold-600);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
